// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"451":"18efc976","629":"55f70ec0"}[chunkId] + ".chunk.css";
};